import React from "react";
import SmartIcon from "../SmartIcon.tsx";
import {GoChevronRight} from "react-icons/go";
import {titleCase} from "../../utils/utils.ts";
import {SeriesTermInfo} from "../../models/interfaces/series.interface.ts";
import iso6391 from "iso-639-1";

interface SeriesTermBasicDetailsProps {
  term: SeriesTermInfo;
  onClick: (termId: string) => void;
  isOpen: boolean;
  onDelete: (termId: string) => void;
}

const SeriesTermBasicDetails: React.FC<SeriesTermBasicDetailsProps> = (
  {
    term,
    onClick,
    isOpen,
    onDelete
  }: SeriesTermBasicDetailsProps) => {

  const onDeleteCharacterClicked = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    e.stopPropagation();
    onDelete(term.termId);
  }

  return (
    <div
      className="flex w-full items-center justify-between gap-4 p-4 rounded-xl hover:bg-n-600 cursor-pointer"
      onClick={() => onClick(term.termId)}
    >
      <div className="flex items-center gap-2">
        <SmartIcon
          name={GoChevronRight}
          className={`w-4 h-4 transition-transform duration-200 ${
            isOpen ? "rotate-90 fill-n-200" : "rotate-0 fill-n-400"
          }`}
        />
        <span className="text-md">{titleCase(term.term)}</span>
        <div className="text-xs text-n-400 ml-2">({iso6391.getName(term.sourceLanguage)})</div>
      </div>
      <div className="cursor-pointer" onClick={onDeleteCharacterClicked}>
        <SmartIcon name="trash" className="w-5 h-5 fill-bloodCrimson-400/80 hover:fill-bloodCrimson-400"/>
      </div>
    </div>
  )
}

export default SeriesTermBasicDetails;